import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from '../../service/company/company.service';
import { CanActivateFn } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { DeepLinkService } from '../../service/deep-link/deep-link.service';

export const defaultRouteGuard: CanActivateFn = () => {
  const router = inject(Router);
  const companyService = inject(CompanyService);
  const deepLink = inject(DeepLinkService);

  console.log('[Guard] Executed on platform:', navigator.userAgent);

  // A cold-start deep link (www.kgdiamonds.com/<stoneName>) must win the
  // initial route, so resolve it here instead of racing the home redirect.
  return from(deepLink.resolveColdStartRoute()).pipe(
    switchMap(deepRoute =>
      deepRoute ? of(deepRoute) : from(companyService.defaultHomePage())
    ),
    switchMap((res: any) => {
      setTimeout(() => {
        router.navigateByUrl(res);
      }, 100);
      return of(false);
    }),
    catchError(error => {
      console.error('[Guard] Error in route guard:', error);
      return of(false); // Block navigation on error
    })
  );
};
